import React from 'react';
import { cn } from '../lib/utils';

/** Многострочный юридический текст: сохраняет переносы и маркеры строк (•). */
export function LegalParagraphs({ text, className }) {
  if (!text) return null;
  return (
    <div
      className={cn(
        'whitespace-pre-line text-[15px] leading-relaxed text-muted-foreground',
        className
      )}
    >
      {text}
    </div>
  );
}
